module.exports = __webpack_public_path__ + "img/btn-move.904c8cab.png";